module.exports = __webpack_public_path__ + "img/icon_address.35be99b1.png";